import React, { useState } from "react";
import { FlexRow } from "@/ui/FlexContainer/FlexContainer";
import Typography from "@/ui/Typography/Typography";
import Textarea from "@/ui/Textarea/Textarea";
import { useTranslation } from "react-i18next";
import { SurveyCheckbox } from "./SurveyCheckbox";
import cls from "./styles.module.scss";

interface QuestionProps {
  question: string;
  number: number;
  quantity: number;
  textareaValue: string;
  textareaOnChange: (answer: string) => void;
  isOwner?: boolean;
  inChat?: boolean;
}

export const Question: React.FC<QuestionProps> = ({
  question,
  number,
  quantity,
  textareaValue,
  textareaOnChange,
  isOwner = false,
  inChat = false,
}) => {
  const { t } = useTranslation();

  const [isVisible, setIsVisible] = useState<boolean>(
    textareaValue === "WITHOUT_RESPONSE"
  );

  const handleVisibilityToggle = () => {
    const newVisibility = !isVisible;
    setIsVisible(newVisibility);

    if (newVisibility) {
      textareaOnChange("WITHOUT_RESPONSE");
    } else if (textareaValue === "WITHOUT_RESPONSE") {
      textareaOnChange("");
    }
  };

  return (
    <div>
      <FlexRow justifyContent="space-between">
        <Typography
          size="md"
          lineHeight="24px"
          weight="medium"
          color="var(--text-dark-primary)"
          className={cls.text}
        >
          {t("surveys.question")} {number}
          <span className={cls.quantity}>/{quantity}</span>
        </Typography>
        {!inChat && isOwner && (
          <FlexRow
            gap={8}
            className={cls.hideBlock}
            onClick={handleVisibilityToggle}
          >
            <SurveyCheckbox
              checked={isVisible}
              onChange={handleVisibilityToggle}
            />
            <Typography
              size="md"
              lineHeight="24px"
              weight="medium"
              color="var(--text-dark-primary)"
              className={cls.text}
            >
              {t("surveys.notNow")}
            </Typography>
          </FlexRow>
        )}
      </FlexRow>
      {!isVisible && (
        <>
          <Typography
            family="Manrope"
            size="2xl"
            lineHeight="32px"
            weight="semibold"
            color="var(--text-brown)"
            className={cls.questionText}
          >
            {question}
          </Typography>

          <Textarea
            value={textareaValue}
            onChange={textareaOnChange}
            placeholder={t("surveys.answerField")}
            disabled={!isOwner || !textareaOnChange}
            className={cls.answer}
          />
        </>
      )}
    </div>
  );
};
